import type { TooltipProps } from '@chakra-ui/react'
import { Grid } from '@chakra-ui/react'
import type { ReactNode } from 'react'
import type { CustomTooltipProps } from './CustomTooltip'
import CustomTooltip from './CustomTooltip'
import { LabelHintIcon } from './icons/LabelHintIcon'

export type HintProps = {
  children: ReactNode
  type?: 'info' | 'warning' | 'error' | 'okapps'
  trigger?: CustomTooltipProps['trigger']
} & TooltipProps

export const Hint = ({
  children,
  type,
  ...rest
}: HintProps) => {
  const bgColor = type === 'warning' ? 'orange.500' : type === 'error' ? 'red.500' : 'primary.500'
  const content = type === 'warning' ? '!' : type === 'error' ? 'X' : '?'

  return (
    <CustomTooltip label={children} hasArrow trigger='clickHover' {...rest}>
      {type === 'okapps' ? (<LabelHintIcon boxSize={4} color='primary.500' />) :
      <Grid
        sx={{
          w: 5,
          h: 5,
          mx: 1,
          placeContent: 'center',
          placeItems: 'center',
          bgColor,
          borderRadius: 'full',
          color: 'white',
          fontSize: 'xs',
          fontWeight: 'medium',
        }}
      >
        {content}
      </Grid>
      }
    </CustomTooltip>
  )
}
